// Generated by Melange

import * as Caml_int32 from "melange.js/caml_int32.js";
import * as Caml_int64 from "melange.js/caml_int64.js";

const land = Caml_int64.and_;

const lsl = Caml_int64.lsl_;

const lsr = Caml_int64.lsr_;

const lor = Caml_int64.or_;

const lxor = Caml_int64.xor;

const $plus = Caml_int64.add;

const $slash = Caml_int64.div;

const $star = Caml_int64.mul;

const $neg = Caml_int64.sub;

const Int64 = {
  land: land,
  lsl: lsl,
  lsr: lsr,
  lor: lor,
  lxor: lxor,
  $plus: $plus,
  $slash: $slash,
  $star: $star,
  $neg: $neg
};

function land$1(prim0, prim1) {
  return prim0 & prim1;
}

function lsl$1(prim0, prim1) {
  return (prim0 << prim1);
}

function lsr$1(prim0, prim1) {
  return (prim0 >>> prim1) | 0;
}

function lor$1(prim0, prim1) {
  return prim0 | prim1;
}

function lxor$1(prim0, prim1) {
  return prim0 ^ prim1;
}

function $plus$1(prim0, prim1) {
  return prim0 + prim1 | 0;
}

const $slash$1 = Caml_int32.div;

function $star$1(prim0, prim1) {
  return Math.imul(prim0, prim1);
}

function $neg$1(prim0, prim1) {
  return prim0 - prim1 | 0;
}

const Int = {
  land: land$1,
  lsl: lsl$1,
  lsr: lsr$1,
  lor: lor$1,
  lxor: lxor$1,
  $plus: $plus$1,
  $slash: $slash$1,
  $star: $star$1,
  $neg: $neg$1
};

export {
  Int64,
  Int,
}
/* No side effect */
